import Vue from "vue";

Vue.filter("dateTime", value => {
  if (!value) {
    return "--/--/-- --:--AM";
  }
  var f = new Date(value);
  const y = new Intl.DateTimeFormat("es", { year: "2-digit" }).format(f);
  const m = new Intl.DateTimeFormat("es", { month: "long" })
    .format(f)
    .substring(0, 2);
  const d = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(f);
  //////////////
  let twoDig = dig => {
    return dig < 9 ? "0" + dig : dig;
  };
  let h = f.getHours();
  let med = h > 11 ? " PM" : " AM";
  h = twoDig(h % 12);
  let min = twoDig(f.getMinutes());
  h = h + ":" + min + med;
  return d + "/" + m + "/" + y + " " + h;
});

Vue.filter("catNombre", idCategoria => {
  let cats = ["", "Res", "Cerdo", "Pollo", "Pez", "Lacteos", "Otros"];
  if (idCategoria > 0 && idCategoria < cats.length) {
    return cats[idCategoria];
  }
  return `Categoria ${idCategoria}`;
});

Vue.filter("moneda", str => {
  let s = new String(str);
  return (
    "$ " +
    s.toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  );
});

Vue.filter("pedido_id2folio", pedido_id => pedido_id.split(":")[1]);
